import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Button,
} from "@mui/material";
import dayjs from "dayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import infoIcon from "../assets/images/info-icon.svg";
import grayInfoIcon from "../assets/images/gray_info.svg";
import closeIcon from "../assets/images/cross-close.svg";
import identityDate from "../assets/images/identity_date.png";
import identity__date_highlight from "../assets/images/identity__date_highlight.png";
import identity_highlight from "../assets/images/identity_highlight.png";
import fileIcon from "../assets/images/fileUpload-icon.svg";
import deleteIcon from "../assets/images/deleteIcon.svg";
import axios from "axios";
import previewPdfUrl from "../assets/images/pdf-icon.svg";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 40px)",
  maxWidth: 467,
  // maxHeight: 324,
  bgcolor: "background.paper",
  borderRadius: "22px",
  boxShadow: 24,
  p: "10px 20px",
};

const Profile2 = ({ commonStyles, setFormValues, formValues, profile_picture_db }) => {
  console.log("formValues", formValues);
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [modalContent, setModalContent] = useState({});
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#000";
    if (formValues.signature) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = formValues.signature;

      img.onload = () => {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };

      img.onerror = (err) => {
        console.error("Failed to load signature image:", err);
      };
    }
  }, [formValues.signature]);

  const startDrawing = (e) => {
    // if (formValues.signature) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { offsetX, offsetY } = getCanvasPosition(e);
    ctx.beginPath();
    ctx.moveTo(offsetX, offsetY);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { offsetX, offsetY } = getCanvasPosition(e);
    ctx.lineTo(offsetX, offsetY);
    ctx.stroke();

    const signatureData = canvas.toDataURL();
    setFormValues((prev) => ({ ...prev, sign: signatureData }));
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const getCanvasPosition = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    let offsetX, offsetY;
    if (e.touches) {
      const touch = e.touches[0];
      offsetX = touch.clientX - rect.left;
      offsetY = touch.clientY - rect.top;
    } else {
      offsetX = e.nativeEvent.offsetX;
      offsetY = e.nativeEvent.offsetY;
    }
    return { offsetX, offsetY };
  };

  const clearCanvas = () => {
    // if (!formValues.signature) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      setFormValues((prev) => ({ ...prev, sign: "" }));
    // }
  };

  const [open, setOpen] = useState(false);
  const [imageDiv, setImageDiv] = useState();
  const [dateModal, setDateModal] = useState(false);

  const handleOpen = (content) => {
    setOpen(true);
    setImageDiv(identityDate);
    setModalContent(content)
  };
  const handleClose = () => setOpen(false);
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(
    formValues?.profile_picture ? formValues.profile_picture : ""
  );
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);
  const [inputSize, setInputSize] = useState(
    window.innerWidth < 1460 ? "small" : "normal"
  );

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#000";

    if (formValues.signature) {
      const img = new Image();
      img.crossOrigin = "anonymous"; 
      img.src = formValues.signature;

      img.onload = () => {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      };

      img.onerror = (err) => {
        console.error("Failed to load signature image:", err);
      };
    }
  }, [formValues.signature]);

  useEffect(() => {
    if (formValues?.profile_picture) {
      setPreviewUrl(formValues.profile_picture);
    }
  }, [formValues?.profile_picture]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setInputSize(window.innerWidth < 1460 ? "small" : "normal");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDrop = async (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];

    if (droppedFile) {
      await handleFileUpload(droppedFile);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleBrowseClick = () => {
    if (!file && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileUpload = async (selectedFile) => {
    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setFormValues((prev) => ({ ...prev, profile_picture: base64String }));

        if (selectedFile.type === "application/pdf") {
          setPreviewUrl("pdf-icon.svg");
        } else {
          setPreviewUrl(URL.createObjectURL(selectedFile));
        }
        setFile(selectedFile);
      };
      reader.readAsDataURL(selectedFile);
      handleCDNUpload(selectedFile);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError("Error uploading file");
    }
  };

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      await handleFileUpload(selectedFile);
      event.target.value = "";
    }
  };

  const handleRemoveFile = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setFile(null);
    setPreviewUrl("");
    setError("");
    setFormValues((prev) => ({ ...prev, profile_picture: "" }));
  };

  const handleInputChange = (field, value) => {
    setFormValues((prev) => ({ ...prev, [field]: value }));
  };

  const theme = createTheme({
    direction: "rtl",
  });
  const handleCDNUpload = (selectedFile) => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("upload_preset", "profile_pics");
    axios
      .post("https://api.cloudinary.com/v1_1/deceg51ej/image/upload", formData)
      .then((cloudinaryResponse) => {
        const imageUrl = cloudinaryResponse.data.secure_url;
        setFormValues((prev) => ({ ...prev, profile_picture: imageUrl }));
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };

  const saveSignature = async () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL("image/png");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", dataURL);
      formData.append("upload_preset", "profile_pics");

      const cloudinaryResponse = await axios.post(
        "https://api.cloudinary.com/v1_1/deceg51ej/image/upload",
        formData
      );
      const imageUrl = cloudinaryResponse.data.secure_url;
      setFormValues((prev) => ({ ...prev, signature: imageUrl }));
      clearCanvas();
    } catch (error) {
      console.error("Error saving signature:", error);
      toast.error("Unable to save data, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2>הגיע הזמן לעשות סדר בפנסיה ובביטוחים שלך</h2>
      <div className="p2_sec_main">
        <div className="p2_sec">
          <div>
            <label className="info_label">
              תאריך הנפקה
            </label>
              <div className="">
            <div className="info_text" onClick={() => handleOpen({ details: "", type: "no_title", title: 'כדי שנוכל לאסוף את נתוני הביטוח מאתר הר הביטוח אנחנו נדרשים לספק את הפרטים הבאים: מספר תעודת זהות, תאריך הנפקה ותאריך לידה. אין מה לדאוג, המידע מוצפן ומאובטח והוא לא ישמר במערכת בסיום התהליך. ' })}>
              <img  className="info_icon" src={infoIcon} alt="info" /> 
                למה אתם צריכים את תאריך ההנפקה שלי ?
              </div>
              <div className="info_text" onClick={() => setDateModal(true)}>
              <img  className="info_icon" src={infoIcon} alt="info" /> 
                  איפה אני מוצא את תאריך ההנפקה שלי ? 
              </div>
            </div>
            <ThemeProvider theme={theme}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="he"
              >
                <div dir="rtl">
                  <DatePicker
                    sx={{
                      ...commonStyles,
                      fontSize: window.innerWidth < 1460 ? "14px" : "16px",
                    }}
                    value={formValues.issueDate}
                    onChange={(newValue) =>
                      handleInputChange("issueDate", newValue)
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: inputSize,
                        sx: {
                          ...commonStyles,
                          fontSize: window.innerWidth < 1460 ? "14px" : "16px",
                        },
                      },
                    }}
                  />
                </div>
              </LocalizationProvider>
            </ThemeProvider>
          </div>
          <div>
            <label className="info_label">
              תאריך לידה
            </label>
            <span className="info_text" onClick={()=>handleOpen({details:"",type:"no_title" ,title:'כדי שנוכל לאסוף את נתוני הביטוח מאתר הר הביטוח אנחנו נדרשים לספק את הפרטים הבאים: מספר תעודת זהות, תאריך הנפקה ותאריך לידה. אין מה לדאוג, המידע מוצפן ומאובטח והוא לא ישמר במערכת בסיום התהליך. '})}>
                       <img
                className="info_icon"
                src={infoIcon}
                alt="info"
              />     <span className="info_text">למה אתם צריכים את תאריך הלידה שלי ?</span>

            </span>
            <ThemeProvider theme={theme}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="he"
              >
                <div dir="rtl">
                  <DatePicker
                    sx={{
                      ...commonStyles,
                      fontSize: window.innerWidth < 1460 ? "14px" : "16px",
                    }}
                    value={formValues.birthDate}
                    onChange={(newValue) =>
                      handleInputChange("birthDate", newValue)
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: inputSize,
                        sx: {
                          ...commonStyles,
                          fontSize: window.innerWidth < 1460 ? "14px" : "16px",
                        },
                      },
                    }}
                  />
                </div>
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </div>
        <div className="p2_sec">
          <FormControl>
            <label>האם אתה מעשן?</label>
            <RadioGroup
              aria-labelledby="smoking-radio-buttons-group"
              name="smoking-radio-buttons-group"
              value={formValues.do_you_smoke}
              onChange={(event) =>
                handleInputChange("do_you_smoke", event.target.value)
              }
              sx={{
                "& .MuiRadio-root": {
                  padding: window.innerWidth < 1460 ? "0" : "9px",
                },
              }}
            >
              <div className="radio_grp">
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="כן"
                  label="כן"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                />
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="לא"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>

          <FormControl>
            <label c>האם יש לך מחלה כרונית?</label>
            <RadioGroup
              aria-labelledby="chronic-disease-radio-buttons-group"
              name="chronic-disease-radio-buttons-group"
              value={formValues.chronic_illness}
              onChange={(event) =>
                handleInputChange("chronic_illness", event.target.value)
              }
              sx={{
                "& .MuiRadio-root": {
                  padding: window.innerWidth < 1460 ? "0" : "9px",
                },
              }}
            >
              <div className="radio_grp">
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="כן"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                  label="כן"
                />
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="לא"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>

          <FormControl>
            <label>האם אתה בתהליך של בדיקה רפואית?</label>
            <RadioGroup
              aria-labelledby="medical-exam-radio-buttons-group"
              name="medical-exam-radio-buttons-group"
              value={formValues.medical_examination}
              onChange={(event) =>
                handleInputChange("medical_examination", event.target.value)
              }
              sx={{
                "& .MuiRadio-root": {
                  padding: window.innerWidth < 1460 ? "0" : "9px",
                },
              }}
            >
              <div className="radio_grp">
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="כן"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                  label="כן"
                />
                <FormControlLabel
                  style={{ marginRight: "0px" }}
                  className="radio_con"
                  value="לא"
                  control={
                    <Radio
                      className="radio_round"
                      sx={{
                        transform:
                          window.innerWidth < 1460 ? "scale(0.8)" : "scale(1)",
                      }}
                    />
                  }
                  label="לא"
                />
              </div>
            </RadioGroup>
          </FormControl>
        </div>
        <div className="p2_sec" style={{ rowGap: "0px" }}>
          <label>זה המקום לצרף את צילום תעודת הזהות שלך</label>
          <div
            className={
              previewUrl === "" ? "file_upload_div" : "file_notUpload_div"
            }
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={handleBrowseClick}
            title="Upload"
          >
            {!previewUrl ? (
              <>
                <img className="file_icon" src={fileIcon} alt="upload-file" />
                <p className="file_desc">
                  גרור ושחרר את תמונת השלט שלך כאן או{" "}
                  <span className="file_span">עיין</span>{" "}
                </p>
                <p className="upload_type">תמיכה: png, jpeg, pdf</p>
                <input
                  type="file"
                  accept="image/png, image/jpeg, application/pdf"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
              </>
            ) : (
              <div className="file_preview">
                {file && file.type === "application/pdf" ? (
                  <img
                    src={previewPdfUrl}
                    alt="PDF File"
                    width={100}
                    className="pdf_icon"
                  />
                ) : (
                  <img
                    src={previewUrl}
                    alt="Uploaded File"
                    className="preview_img"
                  />
                )}
                {/* {!profile_picture_db &&  */}
                <img
                  onClick={handleRemoveFile}
                  className="delete_icon"
                  src={deleteIcon}
                  alt="delete"
                />
                {/* } */}
              </div>
            )}
          </div>
          <></>
        </div>
        <div className="p2_sec">
          <div className="form_box">
            <label>כדי שנוכל לעשות את העבודה בשבילך, אנחנו צריכים את החתימה שלך</label>
            <div className={`signature-container ${formValues.signature ? 'cursor_notallow' : ''}`}>
              <canvas
                ref={canvasRef}
                className="sing_canvas"
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
              />
              {/* {!formValues.signature && ( */}
                <img
                  onClick={clearCanvas}
                  className="delete_icon"
                  src={deleteIcon}
                  alt="delete"
                />
              {/* )} */}
            </div>
            {/* {!formValues.signature && ( */}
              <Button
                onClick={saveSignature}
                disabled={loading}
                className="btn"
                size="medium"
                variant="contained"
                style={{
                  marginTop: "10px",
                  textTransform: "capitalize",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
              >
                {loading ? "חיסכון..." : "שמור חתימה"}
              </Button>
            {/* )} */}
          </div>
        </div>
      </div>

    <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <div className="m-close"onClick={handleClose}>
            <img  src={closeIcon} alt="close" />
          </div>
          {modalContent?.type === "תאריך לידה" ?
            <div>
              <div className="m-image">
                <img src={imageDiv} alt="chart" />
              </div>
              <p className="m-info_label">
                <img src={infoIcon} alt="info" />
                היה טקסטר הדמה הסטנדרטי של התעשייה
              </p>
            </div>
            : <div>
                <span className="m-info_label">
                  <img src={grayInfoIcon} alt="info" />
                    {modalContent?.type!=="no_title" ? <strong>{modalContent?.title}</strong> : modalContent?.title}
                </span>
                <p className="modal-details">{modalContent?.details}</p>
            </div>}
        </Box>
      </Modal>

      <Modal open={dateModal} onClose={()=> setDateModal(false)}>
        <Box sx={style}>
          <div className="m-close"onClick={()=> setDateModal(false)}>
            <img  src={closeIcon} alt="close" />
          </div>

            <div>
              <div className="m-image">
                <img src={identity_highlight} alt="chart" />
              </div>
              <p className="m-info_label">
                <img src={infoIcon} alt="info" />
מיקום תאריך הנפקה בתעודה ביומטרית          </p>
            </div>
            <div>
              <div className="m-image">
                <img src={identity__date_highlight} alt="chart" />
              </div>
              <p className="m-info_label">
                <img src={infoIcon} alt="info" />
מיקום תאריך הנפקה בתעודה רגילה             </p>
            </div>
        </Box>
      </Modal>
    </>
  );
};

export default Profile2;
